import { createNamedStyles } from "../../../../shared/utils";

export const navigatorStyles = createNamedStyles({
  backButton: {
    mt: 3,
  },
});
